import script from "./VerifyEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerifyEmail.vue?vue&type=script&setup=true&lang=ts"

import "./VerifyEmail.vue?vue&type=style&index=0&id=465ecadc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-465ecadc"]])

export default __exports__